const contextPlaceholderFunc = () => {
    throw new Error("Not implemented.");
};

export default contextPlaceholderFunc;
